import { btnGhost } from "./styles";

// Page numbers to show: first, last, and a window around the current page.
const pageWindow = (current: number, last: number): (number | "…")[] => {
  if (last <= 7) return Array.from({ length: last }, (_, i) => i + 1);
  const pages = new Set<number>([1, last, current - 1, current, current + 1]);
  const sorted = Array.from(pages)
    .filter((p) => p >= 1 && p <= last)
    .sort((a, b) => a - b);
  const out: (number | "…")[] = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) out.push("…");
    out.push(p);
  });
  return out;
};

const Pagination = ({
  currentPage,
  lastPage,
  total,
  onPageChange,
}: {
  currentPage: number;
  lastPage: number;
  total?: number;
  onPageChange: (page: number) => void;
}) => {
  if (lastPage < 1) return null;

  return (
    <div className="flex items-center justify-between flex-wrap gap-3 px-5 pt-4 border-t border-hcBorder">
      <p className="text-sm text-hcMuted">
        Page <span className="font-medium text-honeConnectBlack">{currentPage}</span>{" "}
        of <span className="font-medium text-honeConnectBlack">{lastPage}</span>
        {typeof total === "number" && <> · {total.toLocaleString()} results</>}
      </p>

      <div className="flex items-center gap-1.5">
        <button
          className={btnGhost}
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </button>

        {pageWindow(currentPage, lastPage).map((p, i) =>
          p === "…" ? (
            <span key={`gap-${i}`} className="px-1 text-hcMuted">
              …
            </span>
          ) : (
            <button
              key={p}
              title={`page ${p}`}
              onClick={() => onPageChange(p)}
              className={`min-w-[36px] py-2 rounded-lg text-sm font-medium border transition ${
                p === currentPage
                  ? "bg-honeConnectPurple text-white border-honeConnectPurple"
                  : "bg-white text-honeConnectGray border-hcBorder hover:bg-hcBg"
              }`}
            >
              {p}
            </button>
          )
        )}

        <button
          className={btnGhost}
          disabled={currentPage >= lastPage}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
